import { Component, HostListener } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from './services/auth.service';
import { NavigationService } from './services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'autopilot';

  backdropOn = false;
  mode = "side";

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.handleResize();
  }

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    public navigationService: NavigationService,
    public authService: AuthService) {

    iconRegistry.addSvgIcon('logo', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/logo.svg'));
    iconRegistry.addSvgIcon('dashboard', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/dashboard.svg'));
    iconRegistry.addSvgIcon('sales', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/sales.svg'));
    iconRegistry.addSvgIcon('accounting', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/accounting.svg'));
    iconRegistry.addSvgIcon('purchases', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/purchases.svg'));
    iconRegistry.addSvgIcon('payroll', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/payroll.svg'));
    iconRegistry.addSvgIcon('reports', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/reports.svg'));
    iconRegistry.addSvgIcon('settings', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/settings.svg'));

    if (!localStorage.getItem("token")) {
      //router.navigate(["login"]);
    }

    this.handleResize();
  }

  handleResize() {
    if (window.innerWidth < 800) {
      this.backdropOn = true;
      this.mode = "over";
      this.navigationService.hide = true;
    } else {
      this.backdropOn = false;
      this.mode = "side";
      this.navigationService.hide = false;
    }
  }

  backdropClick() {
    this.navigationService.hide = true;
  }
}
